const ProviderImage = ({provider}) => (
  <img
    src={provider.imgSrc}
    alt={`${provider.firstName} ${provider.lastName} MovementX physical therapist in ${provider.primary_location} headshot`}
    loading="lazy"
    width='100%'
    style={{maxWidth: '500px'}}
  />
);

export default ProviderImage;
